import { inject, Injectable, signal } from '@angular/core';
import { SiaAIPromptApi } from '../apis/ai-prompt.api';
import { AIDocumentationCategories } from '../interfaces/ai-documentation-categories';
import { DocumentationOrigin } from '../interfaces/documentation-origin';
import { SiaMcpCollection } from '../interfaces/mcp-tools';

@Injectable({
  providedIn: 'root',
})
export class SiaAIChatService {
  #api = inject(SiaAIPromptApi);
  filesToChatWith = signal<DocumentationOrigin[]>([]);

  constructor() { }

  chat(
    chatUniqueId: string,
    componentType: string,
    componentId: string,
    mode: string,
    hubId: string,
    prompt: string,
    collectionId: string,
    deviceType: string,
    files: { base64: string; mimeType: string }[],
    llmChatHistory: {
      role: 'user' | 'assistant';
      content: string;
    }[],
    selectedDocumentationCategories?: string[],
    selectedChatDocuments: string[] | null = null,
    requestId?: string,
  ): Promise<string> {
    return this.#api.chat(
      chatUniqueId,
      componentType,
      componentId,
      mode,
      hubId,
      prompt,
      collectionId,
      deviceType,
      files,
      llmChatHistory,
      selectedDocumentationCategories,
      selectedChatDocuments,
      requestId, // Pass the requestId for cancellation
    );
  }

  retriveCollections(): Promise<SiaMcpCollection[]> {
    return this.#api.retrieveCollections();
  }

  async downloadDocument(fileSha256: string, fileName: string) {
    var blob: Blob = await this.#api.downloadDocument(fileSha256);
    const fileURL = URL.createObjectURL(blob);
    if (!fileURL) {
      throw 'File URL NULLO';
    }
    if (blob.type && blob.type.toString() == 'application/pdf') {
      window.open(fileURL, '_blank');
    } else {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = fileURL;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
    }
  }

  retrieveOriginInformation(type: string, fileSha256: string): Promise<any> {
    return this.#api.retrieveOriginInformation(type, fileSha256);
  }
  retrieveFileTextContent(sha256: string): Promise<{ textContent: string }> {
    return this.#api.retrieveFileTextContent(sha256);
  }

  getDocumentationCategories(): Promise<AIDocumentationCategories[]> {
    return this.#api.getDocumentationCategories();
  }
}
